import { verifyStudent } from "hooks/allRequests/userApis";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Link from "@mui/material/Link";

function VerifyStudent() {
  const location = useLocation();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  useEffect(async () => {
    const param = location.search.substring(1).split("=");
    const result = await verifyStudent({ verification: param[1] });
    setLoading(false);
    if (result.email) {
      localStorage.setItem("currentUser", JSON.stringify(result));
      navigate("/personalInformation");
    }
  }, []);

  return (
    <>
      <p style={{ textAlign: "center" }}>Էլ-փոստի Հաստատում</p>
      {loading ? (
        <p>Loading...</p>
      ) : (
        <p style={{ textAlign: "center" }}>
          Չհաջողվեց հաստատել Ձեր էլ․ փոստի հասցեն։ Խնդրում ենք
          <Link
            sx={{
              color: "#33C9BF",
              "&:hover": {
                color: "black !important",
              },
            }}
            href="/authentication/sign-up"
          >
            &nbsp;Գրանցվել&nbsp;
          </Link>
          կրկին;
        </p>
      )}
    </>
  );
}
export default VerifyStudent;
